<template>
  <div id="app">
    <!-- <Top @child="handlechild" v-if="$route.path != '/login' && $route.path != '/login'" /> -->
    <Top @child="handlechild" v-if="!router.includes($route.path)" />
    <router-view />
  </div>
</template>
<script>
import Top from '@/components/websiteTop/index'
export default {
  components: {
    Top
  },
  data() {
    return {
      router: ['/login', '/h5Index', '/h5Detail']
    }
  },
  methods: {
    handlechild(val) {
      this.$appData.childData = val
      this.$bus.$emit('childData', val)
    },
  }
}
</script>

<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
}

::v-deep {
  .el-carousel__indicators {
    display: none;
  }
}
</style>